import { initFederation } from '@softarc/native-federation-orchestrator';
import { useShimImportMap } from '@softarc/native-federation-orchestrator/options';

import {
  API_ENDPOINTS,
  FEDERATION_PATHS,
} from './app/core/constants/api.constants';

/**
 * TODO: convert to Top-level await once project is converted to zoneless.
 * Zone.js cannot work with native async/await — must downcompile it.
 */
initFederation(API_ENDPOINTS.FEDERATION_MANIFEST, {
  // Host loads via es-module-shims, so the import map must be written in shim
  // mode or es-module-shims won't read it.
  ...useShimImportMap({ shimMode: true }),
  // Load the host's OWN remoteEntry.json so its shared deps (@angular/core,
  // @angular/common, locales, ...) get import-map entries.
  hostRemoteEntry: FEDERATION_PATHS.hostRemoteEntry,
})
  .then((nf) => import('./bootstrap').then((m) => m.bootstrap(nf)))
  .catch((err) => console.error(err));
